import React, { useState } from 'react';
import { Button, ButtonMode, ButtonProps, ButtonSize, ButtonVariant } from '../../Components/Button';
import { EditIcon } from '../../Components/Icons';
import { MedicationListResponse } from '../../Contracts/MedicationList.Response';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { primary } from '../../Styles/Colours';
import { EditMedicationListDialog } from '../EditMedicationListDialog/EditMedicationListDialog';

export function EditMedicationListButton(
    props: ButtonProps & { medicationList: MedicationListResponse; onComplete(): void }
) {
    const { medicationList, onComplete, ...buttonProps } = props;
    const [showDialog, setShowDialog] = useState(false);
    if (props.medicationList.status === MedicationListStatus.Published) return null;

    return (
        <Button
            {...buttonProps}
            size={ButtonSize.small}
            mode={ButtonMode.border}
            variant={ButtonVariant.light}
            onClick={() => {
                setShowDialog(true);
            }}
            startIcon={<EditIcon noPadding size={'20'} color={primary} />}
        >
            Edit
            {showDialog && (
                <EditMedicationListDialog
                    medicationList={medicationList}
                    onComplete={onComplete}
                    onClose={() => {
                        setShowDialog(false);
                    }}
                />
            )}
        </Button>
    );
}
